import { TableRow, styled } from "@mui/material"

/**
 * Styled table row component to be used across the app. Removes bottom border.
 * Do not use for headings
 */
const AppTableContentRow = styled(TableRow)(() => ({
    "&:last-child th, &:last-child td": {
        borderBottom: 0,
    },
}))

export default AppTableContentRow
